import type { GridColDef } from '@mui/x-data-grid';
import type { Currency, Months, YearlyRevenue } from '@weft/types';
import { Price } from 'apps/app/src/components/design/Price';
import { VyTableCell } from 'apps/app/src/components/new-design/table/vy-table/VyTableCell';

export type ContractBillingScheduleColumns = {
  id: string;
  item: string;
  amount: number;
  yearlyRevenue: YearlyRevenue;
};

export const CONTRACT_PAGE_BILLING_SCHEDULE_COLUMNS_KEYS = Object.freeze({
  ID: 'id',
  ITEM: 'item',
  AMOUNT: 'amount',
} satisfies Record<string, keyof ContractBillingScheduleColumns>); 

export const getContractPageBillingScheduleColumns = (revenueColumnKeys: { year: string, month: Months }[], currency: Currency): GridColDef<ContractBillingScheduleColumns>[] => [
  {
    field: CONTRACT_PAGE_BILLING_SCHEDULE_COLUMNS_KEYS.ITEM,
    headerName: 'Item',
    headerClassName: 'text-sm',
    headerAlign: 'center',
    align: 'center',
    cellClassName: 'pl-10',
    width: 160,
    renderCell: ({ row: { item } }) => <VyTableCell value={item}/>,
  },
  {
    field: CONTRACT_PAGE_BILLING_SCHEDULE_COLUMNS_KEYS.AMOUNT,
    headerName: 'Amount',
    headerClassName: 'text-sm',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    renderCell: ({ row: { amount } }) => (
      <Price currency={currency}>
        {amount}
      </Price>
    ),
  },
  ...revenueColumnKeys.map<GridColDef<ContractBillingScheduleColumns>>(({ year, month }) => ({
    field: `${year}-${month}`,
    headerName: `${month} ${year}`,
    headerClassName: 'text-sm',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    renderCell: ({ row }) => {
      const revenuePerMonthBreakdown = row.yearlyRevenue[year][month];
      const revenue = revenuePerMonthBreakdown?.scheduledCharge ?? 0;

      return (
        <Price currency={currency}>
          {revenue}
        </Price>
      );
    },
  })),
];